import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export interface AnnouncementFilters {
  searchKey: string
  selectedTabs: string[]
  years: string[]
  currPage: number
}

interface AnnouncementFiltersState extends AnnouncementFilters {
  setFilters: (data: Partial<AnnouncementFilters>) => void
  resetFilters: () => void
}

export const defaultAnnouncementFilters: AnnouncementFilters = {
  searchKey: '',
  selectedTabs: ['All'],
  years: ['All Years'],
  currPage: 1
}

const STORAGE_KEY = 'announcement-filters'

export const useAnnouncementFiltersStore = create<AnnouncementFiltersState>()(
  persist(
    set => ({
      ...defaultAnnouncementFilters,
      setFilters: data => set(state => ({ ...state, ...data })),
      resetFilters: () => set({ ...defaultAnnouncementFilters })
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() =>
        typeof window !== 'undefined'
          ? window.localStorage
          : {
              getItem: () => null,
              setItem: () => undefined,
              removeItem: () => undefined
            }
      ),
      partialize: state => ({
        searchKey: state.searchKey,
        selectedTabs: state.selectedTabs,
        years: state.years,
        currPage: state.currPage
      })
    }
  )
)
